import fetch from 'isomorphic-fetch'

import {
  FETCH_POPULAR_FAQS,
  FETCH_POPULAR_FAQS_FULFILLED,
  FETCH_POPULAR_FAQS_REJECTED,
  FETCH_FAQ_CONTENT,
  FETCH_FAQ_CONTENT_FULFILLED,
  FETCH_FAQ_CONTENT_REJECTED,
  FETCH_FAQ_BY_SEARCH,
  FETCH_FAQ_BY_SEARCH_FULFILLED,
  FETCH_FAQ_BY_SEARCH_REJECTED
} from './types'

export function fetchPopularFAQs (fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/helpfaq-assets/static/data/' : '/helpfaq-assets/static/data/'
  return dispatch => {
    dispatch(beginPopularFAQs())
    return fetch(url + 'popularFAQs.json')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(results => {
        return dispatch(retrievePopularFAQs(results))
      })
      .catch(error => {
        return dispatch(errorPopularFAQs(error))
      })
  }
}

export function beginPopularFAQs () {
  return {
    type: FETCH_POPULAR_FAQS
  }
}

export function retrievePopularFAQs (results) {
  return {
    type: FETCH_POPULAR_FAQS_FULFILLED,
    payload: results
  }
}

export function errorPopularFAQs (error) {
  return {
    type: FETCH_POPULAR_FAQS_REJECTED,
    payload: error
  }
}

export function fetchFAQContent (faqId, fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/helpfaq-assets/static/data/faqs/' : '/helpfaq-assets/static/data/faqs/'
  return dispatch => {
    dispatch(beginFAQContent())
    return fetch(url + faqId + '.json')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(result => {
        return dispatch(retrieveFAQContent(result))
      })
      .catch(error => {
        return dispatch(errorFAQContent(error))
      })
  }
}

export function beginFAQContent () {
  return {
    type: FETCH_FAQ_CONTENT
  }
}

export function retrieveFAQContent (result) {
  return {
    type: FETCH_FAQ_CONTENT_FULFILLED,
    payload: result
  }
}

export function errorFAQContent (error) {
  return {
    type: FETCH_FAQ_CONTENT_REJECTED,
    payload: error
  }
}

export function fetchFAQBySearch (searchTerm, fromServer = false) {
  const errorMessage = 'Bad response from server'
  let url = fromServer ? 'http://127.0.0.1:3000/suggest' : '/suggest'
  return dispatch => {
    dispatch(beginFAQBySearch())
    return fetch(url + '?includeFaq=true&term=' + searchTerm)
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(results => {
        return dispatch(retrieveFAQBySearch(results, searchTerm))
      })
      .catch(error => {
        return dispatch(errorFAQBySearch(error))
      })
  }
}

export function beginFAQBySearch () {
  return {
    type: FETCH_FAQ_BY_SEARCH
  }
}

export function retrieveFAQBySearch (results, searchTerm) {
  return {
    type: FETCH_FAQ_BY_SEARCH_FULFILLED,
    payload: { results, searchTerm }
  }
}

export function errorFAQBySearch (error) {
  return {
    type: FETCH_FAQ_BY_SEARCH_REJECTED,
    payload: error
  }
}
